const DEFAULT_REFRESH_WINDOW_SECONDS = 60;

export const shouldRefreshSession = (
  session,
  nowMs = Date.now(),
  refreshWindowSeconds = DEFAULT_REFRESH_WINDOW_SECONDS,
) => {
  if (!session?.access_token || !session?.expires_at) return true;

  const secondsUntilExpiry = session.expires_at - Math.floor(nowMs / 1000);
  return secondsUntilExpiry <= refreshWindowSeconds;
};
